import { render, staticRenderFns } from "./VirtualGiftModalItem.vue?vue&type=template&id=74a79b70&scoped=true&"
import script from "./VirtualGiftModalItem.vue?vue&type=script&lang=js&"
export * from "./VirtualGiftModalItem.vue?vue&type=script&lang=js&"
import style0 from "./VirtualGiftModalItem.vue?vue&type=style&index=0&id=74a79b70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a79b70",
  null
  
)

export default component.exports